// extracted by mini-css-extract-plugin
module.exports = {"formWraper":"productForm_formWraper__18Hsj","invalid":"productForm_invalid__2Efpz","input":"productForm_input__1JjZ-","select":"productForm_select__LTWpB"};